import { Injectable } from '@angular/core';
import {  Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { BaseState } from '../../reducers';
import { MessageService } from 'primeng/api';
import { FirebaseFirestoreService } from '../../services/firebase-firestore.service';
import { UserActions } from './user.actions';
import { EMPTY, map, switchMap, tap, withLatestFrom } from 'rxjs';

@Injectable()
export class UserEffects {
  constructor(
    private messageService: MessageService,
    private actions$: Actions,
    private store: Store<BaseState>,
    private firebaseFirestoreService: FirebaseFirestoreService
  ) {}

  copyToClipboard$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UserActions.copyRenderId),
      withLatestFrom(
        this.store.select(state => state.user?.openRenderPipelineId),
      ),
      tap(([, renderPipelineId]) => {
        if (!renderPipelineId) {
          this.messageService.add({severity: 'error', summary: 'Copy issue', detail: 'Something went wrong copying the render ID.'});
          return
        }
        this.messageService.add({severity: 'success', summary: 'Copied', detail: 'Render ID copied to clipboard.'});
        navigator.clipboard.writeText(renderPipelineId);
      })
    )
  }, {dispatch: false});
}

